import React, { Component } from "react";
import { Row, Card, CardTitle } from "reactstrap";
import { connect } from "react-redux";
import { loginUser, logoutUser, setLoader } from "../../redux/actions";
import { Colxx } from "../../components/common/CustomBootstrap";
import { NotificationManager } from "../../components/common/react-notifications";
import { logo } from "../../config/defaultValues";
import {getValueOfParameterFromURL} from "../../helpers/Utils";
import AppLocale from "../../config/lang";
import FormCustom from "../../components/utils/FormCustom";
import _axios from "../../libs/axios";
import countryCodes from '../../data/countryCodes'
import Dialog from "../../components/utils/Dialog";
// import { goToWhatsApp } from "../../helpers/Utils";

class Register extends Component {
  constructor(props) {
    // console.log(props)
    super(props);
    this.state = {
      form: null,
      formFields: [],
      formButtons: [],
      pinSent: false,
      verifiedNumber: false,
      readyForm: false,
      dialog: {
        isOpen: false,
        toggle: () => {},
        title: null,
        msg: null,
        confirm: () => {}
      }
    }
  }

  UNSAFE_componentWillMount () {
    this.getParamsFromURL()
    .then(() => {
      this.createForm()
    })
    .catch((error) => {
      console.error(error.message);
    }) 
  }

  componentDidMount () {
    let form = this.state.form
    let code = parseInt(localStorage.getItem('countryCode'))
    form = {...form, ...{countryCode: code?? ''}}
    this.setState({form: form})
  }

  getParamsFromURL = () => {
    return new Promise((resolve, reject) => {
      try {
        let plan = getValueOfParameterFromURL("plan")
        if (plan) {
          let form = this.state.form
          form = { form, ...{ plan: plan } }
          this.setState({ form: form}, () => {
            resolve()
          })
        } else resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  createForm = () => {
    const fields = [
      {
        col: 4,
        colxs: 4,
        name: "countryCode",
        value: this.state.form?.countryCode,
        type: "select",
        placeholder: "main.plusCountryCode",
        rules: "required",
        opts: {
          colClassName: "pr-0",
          items: countryCodes,
          isClearable: false,
          filterOption: (option, searchText) => {
            let label = option.data.label.split(" ")
            if (label[1].toLowerCase().startsWith(searchText.toLowerCase()) || label[0].toLowerCase().includes(searchText.toLowerCase())) {
              return true;
            } else {
              return false;
            }
          }
        },
        onChange: (ctx) => {
          if (ctx.state.countryCode) localStorage.setItem('countryCode', ctx.state.countryCode)
        }
      },
      {
        col: 8,
        colxs: 8,
        id: "mobile",
        name: "mobile",
        value: "",
        type: "number",
        placeholder: "main.mobileNumber",
        rules: "required|max:9",
        onKeyPress: e => e.key === 'Enter' ? this.verifyNumber() : null,
        opts: {
          colClassName: "pl-0",
          addon: {
            append: {
              buttons: [
                {
                  icon: "icomoon-message",
                  className: "btn-send-phoneNumber",
                  outline: () => this.state.pinSent,
                  onClick: () => { this.verifyNumber() }
                }
              ]
            }
          }
        }
      },
      {
        col: 12,
        name: "code",
        value: "",
        type: "number",
        label: "",
        rules: "required",
        onKeyPress: e => e.key === 'Enter' ? this.login() : null,
        opts: {
          addon: {
            prepend: {
              texts: ["main.otp"]
            }
          }
        },
        renderIf: () => this.state.pinSent
      },
      {
        col: 12,
        name: "plan",
        value: this.state.form?.plan?? "",
        type: "select",
        label: "Plan",
        placeholder: "main.selectPlan",
        rules: ['required'],
        opts: {
          style: 'float-label',
          items: [
            {value: "Starter", label: "Starter"},
            {value: "Empower", label: "Empower"},
            {value: "Custom", label: "Custom"}
          ]
        },
        renderIf: () => false && this.state.pinSent && this.state.verifiedNumber
      },
      {
        col: 6,
        name: "name",
        value: "",
        type: "text",
        label: L => `${L["main.company"]} ${L["main.name"]?.toLowerCase()}`,
        rules: "required",
        opts: {
          style: 'float-label',
        },
        renderIf: () => this.state.pinSent && this.state.verifiedNumber
      },
      {
        col: 6,
        name: "email",
        value: "",
        type: "text",
        label: L => `${L["main.company"]} ${L["main.email"]?.toLowerCase()}`,
        rules: "required|email",
        opts: {
          style: 'float-label',
        },
        renderIf: () => this.state.pinSent && this.state.verifiedNumber
      },
      {
        col: 4,
        colxs: 5,
        name: "countryCode2",
        value: "",
        type: "select",
        label: "main.countryCode",
        rules: "required",
        opts: {
          style: 'float-label',
          items: countryCodes,
          isClearable: false,
          filterOption: (option, searchText) => {
            let label = option.data.label.split(" ")
            if (label[1].toLowerCase().startsWith(searchText.toLowerCase()) || label[0].toLowerCase().includes(searchText.toLowerCase())) {
              return true;
            } else {
              return false;
            }
          }
        },
        renderIf: () => this.state.pinSent && this.state.verifiedNumber
      },
      {
        col: 8,
        colxs: 7,
        name: "companyPhone",
        value: "",
        type: "number",
        label: L => `${L["main.company"]} ${L["main.phone"]?.toLowerCase()}`,
        rules: "required|max:9",
        opts: {
          style: 'float-label',
        },
        renderIf: () => this.state.pinSent && this.state.verifiedNumber
      },
      {
        col: 12,
        name: "alias",
        value: "",
        type: "text",
        label: "",
        placeholder: "main.alias",
        rules: ['required', {regex:'^[a-zA-Z0-9-]*$'}],
        opts: {
          style: 'float-label',
          addon: {
            append: {
              texts: [window.location.host.replace("app.", ".").replace("dev-app.", ".")]
            }
          }
        },
        renderIf: () => this.state.pinSent && this.state.verifiedNumber
      },
      {
        col: 12,
        name: "msg",
        value: L => `<div class="text-small">${L["main.startCreateAccountB"]}</div>`,
        type: "label",
        renderIf: () => !this.state.pinSent
      },
      // {
      //   col: 12,
      //   name: "btnWhatsApp",
      //   value: "",
      //   label: "main.tryOnWhatsapp",
      //   type: "button",
      //   className: "d-flex align-items-center",
      //   opts: {
      //     outline: true,
      //     icon: "icomoon-whatsapp",
      //     kind: "success",
      //     iconStyle: {fontSize: "20px", marginRight: "8px"},
      //   },
      //   onClick: () => goToWhatsApp(window.tenant.isPro ? "15744440040" : "14159430840", "Hello"),
      //   renderIf: () => !this.state.pinSent
      // }
    ]

    const buttons =  [
      {
        col: 12,
        name: "btnSentPin",
        type: "button",
        label: "main.continue",
        onClick: () => { this.login() },
        renderIf: () => this.state.pinSent && !this.state.verifiedNumber
      },
      {
        col: 12,
        name: "btnRegister",
        type: "button",
        label: "main.register",
        onClick: () => { this.register() },
        renderIf: () => this.state.pinSent && this.state.verifiedNumber
      }
    ]

    this.setState({formFields: fields, formButtons: buttons}, () => {
      this.setState({readyForm: true})
    })
  }

  listenStatesForm = (s) => {
    this.setState({ form: s });
  }

  verifyNumber = () => {
    this.validateFor(null, ['countryCode', 'mobile']).then(() => {
      this.props.setLoader(true)
      _axios
        .post('user/mauthpin', {user: `${this.state.form.countryCode}${this.state.form.mobile}`})
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) this.setState({pinSent: true}, () => {
            setTimeout(() => { document.getElementById("form-register-code").focus()}, 500)
          })
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(validationFailed => {
      // console.log(validationFailed)
    })
  }

  login = () => {
    this.validateForm().then(() => {
      this.props.setLoader(true)
      _axios
        .post('user/login', {user: `${this.state.form.countryCode}${this.state.form.mobile}`, pass: this.state.form.code})
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            this.setState({verifiedNumber: true})
            this.props.loginUser(r.data, this.props.history, false)
          }
          NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  register = () => {
    this.validateForm().then(() => {
      this.props.setLoader(true)
      _axios
        .post('company/setup', {
          email: this.state.form.email, 
          cel: `${this.state.form.countryCode2}${this.state.form.companyPhone}`, 
          name: this.state.form.name, 
          alias: this.state.form.alias,
          plan: this.state.form.plan
        })
        .then(r => {
          this.props.setLoader(false)
          if (r.status >= 0) {
            this.props.logoutUser(this.props.history)
            this.setState({dialog: {
              isOpen: true,
              toggle: () => {
                let d = this.state.dialog
                d.isOpen = !d.isOpen
                this.setState({dialog: d})
              },
              msg: r.msg,
              confirm: (e) => {
                if (e) window.location.assign(`https://${r.data.alias}.${window.location.host.replace("app.", "").replace("dev-app.", "")}/adm/`);
                this.state.dialog.toggle()
              },
              btnOkName: "main.launchAdmin",
              btnCancelHidden: true
            }})
          } else NotificationManager['error'](r.msg, 'Opps', 5000, null, null, 'outline')
        })
        .catch((e) => { this.props.setLoader(false) })
    })
    .catch(e => { /* console.log(e) */ })
  }

  render() {
    const L = AppLocale[this.props.locale].messages
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side d-flex justify-content-center align-items-center" style={{backgroundColor: `var(--theme-color-1)`}}>
              <img src={logo} alt="" className="w-50 rounded-circle"/>
            </div>
            <div className="form-side">
              <CardTitle className="mb-4">
                {L["main.registerTenant"]}
              </CardTitle>
              {this.state.readyForm && <FormCustom
                id={"form-register"}
                fields={this.state.formFields}
                buttons={this.state.formButtons}
                listenStates={this.listenStatesForm}
                validate={fn => this.validateForm = fn}
                validateFor={fn => this.validateFor = fn}
              />}
            </div>
          </Card>
        </Colxx>
        <Dialog {...this.state.dialog}></Dialog>
      </Row>
    )
  }
}

const mapStateToProps = ({ authUser, settings }) => {
  const { user } = authUser;
  const { locale } = settings
  return { user, locale };
};

export default connect(mapStateToProps, { loginUser, logoutUser, setLoader})(Register);
